// TES-1034 — the request one journal box sends for its AI help, shared by the
// care meeting's note and the prescription transfer review's note so the two
// cannot drift: "Sammanfatta" sends only the heading (the server reads that
// heading's own prefill), "Sammanställ" sends the box's text as it stands.
//
// Pure on purpose (only type imports) so `node --test` can run it.
import type {
  JournalAiMode,
  JournalSectionAiRequest,
  JournalSectionKey,
} from "@care-by-ella/contracts";

export function journalSectionAiRequest(
  key: string,
  mode: JournalAiMode,
  text: string,
): JournalSectionAiRequest {
  return {
    sectionKey: key as JournalSectionKey,
    mode,
    ...(mode === "compose" ? { text } : {}),
  };
}

/**
 * Whether the AI help is offered, from the availability probe's outcome:
 * true when it answered, false when the server said the switch is off, null
 * (not offered) for anything else, so a failed probe hides the buttons
 * rather than showing ones that cannot work.
 */
export function aiAvailabilityFrom(
  outcome: "ok" | "disabled" | "error",
): boolean | null {
  if (outcome === "ok") return true;
  if (outcome === "disabled") return false;
  return null;
}
